import Vue from "vue";
import { SelectTimeInterface } from "./SelectTimeInterface";

const SelectTimeProps = Vue.extend({
  props: {
    clinicId: [Number, String],
    date: String,
    time: [Object as () => SelectTimeInterface],
    loading: Boolean,
    showMessage: Boolean,
  },
});

export default SelectTimeProps;
